module.exports = __webpack_public_path__ + "static/img/14000127.bfcfb82c.png";